<template>
    <b-overlay
        class="h-100"
        :show="loadingStatus === 'loading'"
    >
        <b-card class="h-full">
            <SideBarTotalCost
                :isNoContent="isNoContent"
                :editMode="editMode"
            />
            <template v-if="isNoContent && !editMode">
                <h2 class="text-right">
                    {{ $t('v4.Not Available') }}
                </h2>
            </template>
            <template v-else>
                <hr v-show="estimatable">
                <SideBarDownload/>
                <hr v-show="estimatable && status !== 'loading'">
                <SideBarMonthlyCost/>
            </template>
        </b-card>
    </b-overlay>
</template>

<script>
import useSelectMonth from '@/composables/useSelectMonth'
import useDashboard from '@/composables/useDashboard'
import SideBarTotalCost from './SideBarTotalCost'
import SideBarDownload from './SideBarDownload'
import SideBarMonthlyCost from './SideBarMonthlyCost'
import { getCurrentInstance, computed, watch } from '@vue/composition-api'
export default {
    props: ['editMode'],
    components: {
        SideBarTotalCost,
        SideBarDownload,
        SideBarMonthlyCost
    },
    setup (props, context) {
        const vm = getCurrentInstance().proxy
        const store = vm.$store
        const currentParams = computed(() => store.getters['$_dashboard/currentParams'])
        const { getCostByMonth, getTotalCost } = useDashboard()
        const [status] = getCostByMonth(currentParams.value)
        const [loadingStatus] = getTotalCost()
        const isNoContent = computed(() => status.value === 204)
        const { estimatable } = useSelectMonth()
        watch(currentParams, (value, oldValue) => {
            getCostByMonth(value)
        }, {
            deep: true
        })
        return {
            loadingStatus,
            isNoContent,
            status,
            estimatable
        }
    }
}
</script>

<style>

</style>
